import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

import QRCode from "qrcode";
import logo from "./zulu.png";


// ==============================
// STYLES
// ==============================
const styles = StyleSheet.create({
  page: {
    paddingTop: 40,
    paddingBottom: 60,
    paddingHorizontal: 30,
    fontSize: 10,
    fontFamily: "Helvetica",
  },

  headerContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
    borderBottom: "2 solid #000",
    paddingBottom: 10,
  },

  leftHeader: {
    flexDirection: "row",
    width: "75%",
  },

  logo: {
    width: 70,
    height: 70,
    marginRight: 15,
  },

  titleContainer: {
    flexDirection: "column",
  },

  title: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 5,
  },

  subTitle: {
    fontSize: 10,
    marginBottom: 2,
  },

  reportInfo: {
    marginBottom: 15,
  },

  infoText: {
    fontSize: 10,
    marginBottom: 3,
  },

  table: {
    display: "table",
    width: "100%",
    borderWidth: 1,
  },

  tableRow: {
    flexDirection: "row",
  },

  tableHeader: {
    backgroundColor: "#111827",
  },

  tableCol: {
    borderWidth: 1,
    padding: 5,
  },

  col1: { width: "6%" },
  col2: { width: "28%" },
  col3: { width: "12%" },
  col4: { width: "18%" },
  col5: { width: "18%" },
  col6: { width: "18%" },

  tableCell: {
    fontSize: 9,
  },

  tableHeaderText: {
    fontSize: 10,
    fontWeight: "bold",
    color: "#fff",
  },

  totalSection: {
    marginTop: 20,
    alignItems: "flex-end",
  },

  totalText: {
    fontSize: 12,
    fontWeight: "bold",
  },

  footer: {
    position: "absolute",
    bottom: 20,
    left: 30,
    right: 30,
    flexDirection: "row",
    justifyContent: "space-between",
  },

  qrImage: {
    width: 70,
    height: 70,
  },
});


// ==============================
// PDF COMPONENT
// ==============================
const ProfitGeneratePdf = ({ data = [], totalProfit = 0 }) => {

  const [qrCode, setQrCode] = React.useState("");

  React.useEffect(() => {
    QRCode.toDataURL(JSON.stringify({ totalProfit, data }))
      .then(setQrCode);
  }, [data, totalProfit]);


  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>

        {/* ================= HEADER ================= */}
      <View fixed>
          <View style={styles.headerContainer}>

            <View style={styles.leftHeader}>
              <Image src={logo} style={styles.logo} />

              <View style={styles.titleContainer}>
                <Text style={styles.title}>
                  Profit Analytics Financial Report
                </Text>

                <Text style={styles.subTitle}>
                  Johnsonville, Monrovia Liberia
                </Text>

                <Text style={styles.subTitle}>
                  Email: info@yourcompany.com
                </Text>

                <Text style={styles.subTitle}>
                  Contact: +231-77-000-0000
                </Text>
              </View>
            </View>

          </View>

          <View style={styles.reportInfo}>
            <Text style={styles.infoText}>
              Product Profit Performance Report
            </Text>
          </View>
        </View>

        {/* ================= TABLE ================= */}
        <View style={styles.table}>

          {/* HEADER */}
          <View style={[styles.tableRow, styles.tableHeader]}>

            <View style={[styles.tableCol, styles.col1]}>
              <Text style={styles.tableHeaderText}>#</Text>
            </View>

            <View style={[styles.tableCol, styles.col2]}>
              <Text style={styles.tableHeaderText}>Product</Text>
            </View>

            <View style={[styles.tableCol, styles.col3]}>
              <Text style={styles.tableHeaderText}>Qty</Text>
            </View>

            <View style={[styles.tableCol, styles.col4]}>
              <Text style={styles.tableHeaderText}>Unit Profit</Text>
            </View>

            <View style={[styles.tableCol, styles.col5]}>
              <Text style={styles.tableHeaderText}>Selling Price</Text>
            </View>

            <View style={[styles.tableCol, styles.col6]}>
              <Text style={styles.tableHeaderText}>Total Profit</Text>
            </View>

          </View>

          {/* BODY */}
          {data.map((item, index) => (
            <View style={styles.tableRow} key={index} wrap={false}>

              {/* INDEX */}
              <View style={[styles.tableCol, styles.col1]}>
                <Text style={styles.tableCell}>{index + 1}</Text>
              </View>

              {/* PRODUCT */}
              <View style={[styles.tableCol, styles.col2]}>
                <Text style={styles.tableCell}>
                  {item.product ?? item.name ?? "N/A"}
                </Text>
              </View>

              {/* QTY */}
              <View style={[styles.tableCol, styles.col3]}>
                <Text style={styles.tableCell}>
                  {item.quantity_sold ?? item.units_sold ?? 0}
                </Text>
              </View>

              {/* UNIT PROFIT */}
              <View style={[styles.tableCol, styles.col4]}>
                <Text style={styles.tableCell}>
                  ${Number(item.profit_per_unit || 0).toFixed(2)}
                </Text>
              </View>

              {/* SELLING PRICE */}
              <View style={[styles.tableCol, styles.col5]}>
                <Text style={styles.tableCell}>
                  ${Number(item.selling_price || 0).toFixed(2)}
                </Text>
              </View>

              {/* TOTAL PROFIT */}
              <View style={[styles.tableCol, styles.col6]}>
                <Text style={styles.tableCell}>
                  ${Number(item.total_profit || 0).toFixed(2)}
                </Text>
              </View>

            </View>
          ))}

        </View>

        {/* ================= TOTAL ================= */}
        <View style={styles.totalSection}>
          <Text style={styles.totalText}>
            Grand Total Profit: ${Number(totalProfit).toFixed(2)}
          </Text>
        </View>

        {/* ================= FOOTER ================= */}
        <View style={styles.footer} fixed>

          {qrCode && (
            <Image src={qrCode} style={styles.qrImage} />
          )}

        </View>

      </Page>
    </Document>
  );
};

export default ProfitGeneratePdf;